export class ResponseSizePKModel {

    codSize: string;
    grupoSz: string;

    constructor() { }
}